import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { getToAuthorize } from './api'

const onError = (error: Error) => {
  console.error(error)
}

const useToAuthorize = () => {
  const { data, isLoading } = useQuery([QUERY_KEYS.TO_AUTHORIZE], getToAuthorize, {
    refetchInterval: 10000,
    onError,
    enabled: false,
  })

  return { data, isLoading }
}

export { useToAuthorize }
